import { api, throwApiError } from "../../../api/api";
import type { DpPaginated } from "./dpTypes";

export type DpPendencyCategory = "DOCUMENTOS" | "CONTRATO" | "ADICIONAIS" | "DEPENDENTES" | "FICHA";

export const PENDENCY_CATEGORY_LABELS: Record<DpPendencyCategory, string> = {
  DOCUMENTOS: "Documentos",
  CONTRATO: "Contrato",
  ADICIONAIS: "Adicionais",
  DEPENDENTES: "Dependentes",
  FICHA: "Ficha",
};

export type DpPendency = {
  id: string;
  category: DpPendencyCategory;
  description: string;
  createdAt: string;
};

export type DpEmployeeWithPendencies = {
  id: string;
  fullName: string;
  cpf: string | null;
  registrationNumber: string | null;
  pendencies: DpPendency[];
};

export type DpPendenciesSummary = { employees: number; pendencies: number };

const auth = (token: string) => {
  const raw = token?.startsWith("Bearer ") ? token.slice(7) : token;
  return { headers: { Authorization: `Bearer ${raw}` } };
};

export const getPendenciesSummaryApi = async (token: string): Promise<DpPendenciesSummary> => {
  try {
    const { data } = await api.get<DpPendenciesSummary>("/dp/pendencies/summary", auth(token));
    return data;
  } catch (error) {
    throwApiError(error, "Erro ao consultar as pendências de cadastro.");
    throw error;
  }
};

export const listPendenciesApi = async (
  token: string,
  params: { page?: number; limit?: number; q?: string } = {}
): Promise<DpPaginated<DpEmployeeWithPendencies>> => {
  try {
    const { data } = await api.get<DpPaginated<DpEmployeeWithPendencies>>("/dp/pendencies", {
      ...auth(token),
      params,
    });
    return data;
  } catch (error) {
    throwApiError(error, "Erro ao listar as pendências de cadastro.");
    throw error;
  }
};

export const resolvePendencyApi = async (token: string, id: string): Promise<void> => {
  try {
    await api.patch(`/dp/pendencies/${id}/resolve`, {}, auth(token));
  } catch (error) {
    throwApiError(error, "Erro ao resolver a pendência.");
  }
};
